import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { from, map, Observable } from 'rxjs';

import { AuthorizationService } from '@services/authorization.service';
import { appStateStore } from '@shared/stores/app-state.store';

@Injectable({
  providedIn: 'root',
})
export class AuthorizationGuard {
  private readonly stateStore = inject(appStateStore);

  constructor(
    private readonly authService: AuthorizationService,
    private readonly router: Router,
  ) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
    return from(this.authService.checkForAuthentication()).pipe(
      map(authenticated => {
        if (authenticated) {
          return true;
        } else {
          this.stateStore.removeState();
          this.router.navigate(['/']).then();
          return false;
        }
      }),
    );
  }
}
